import { flatMap } from "rxjs/operators";
import { MatrixState, RootState } from "./types";

// @ref https://github.com/kelektiv/node-uuid
const windowId = new Date().valueOf().toString();

export function getDefaultState(): RootState {
	return {
		appInitialised: false,
		dataError: false,
		showRoutingGroupsLegend: false,
		windowId,
		User: {
			userId: null,
			userGroupId: null,
			loggedIn: false,
			fullName: "",
			error: "",
			isFullUser: false,
			useImperialMeasurements: false,
			userPermissions: {
				canManageContactRoles: false,
				canEditSettings: false,
				canHandleAlarms: false,
				canInteractHighPriorityBanner: false,
				canViewReports: false,
				canAddIndividualActions: false,
				canEditUserPermissions: false,
				canEditUserGroups: false,
				canViewSiteSetup: false,
				canEditSiteSetup: false,
				canRaiseActivityLog: false,
				canToggleLogVisibility: false,
				canEditOwnActivityLog: false,
				canEditOtherActivityLogs: false,
				isAdmin: false,
				canDisarmSites: false,
				canDisarmSitesExtended: false,
				canSetResponseToMasked: false,
				canSetSiteToOnTest: false,
				canSetSiteToAuditMode: false,
				canViewEvents: false,
				canAccessQuickControl: false,
				canViewMediaMatrisControls: false,
				canAccessManualRaise: false,
				canAccessManualTour: false,
				canViewSitRep: false,
				canUseMobile: false,
				canViewMobileRaise: false,
				canEditMobileRaise: false,
				canDownloadEventSearchSitRep: false,
				canDownloadEventSearchMedia: false,
				canViewLicenseDetails: false,
				canViewActivityLogManagement: false,
				canPerformVideoReport: false,
				canPerformVideoReportUpload: false,
				canProcessActiveAlarms: false,
				canDownloadSingleClip: false,
				canViewExternalMapLayers: false,
				canEditExternalMapLayers: false,
				canEditInsightsTitle: false,
				canExtendAlerts: false,
				canEditMaps: false,
				canEditSystemSettings: false,
				canEditEventCategorySetup: false,
				canEditGuardTours: false,
				canViewGuardTours: false,
				canEnableDisableUsers: false,
				canAssignGuardTour: false,
				canConductGuardTour: false,
				canClaimFromMobileRaise: false,
				canMobileDispatch: false,
				canAccessQuickControlEvents: false,
				canAccessVideowall: false,
				canViewSystemEvents: false,
				canViewSiteArmedState: false,
				canEndMultipleAlarms: false,
				canChangeGuardType: false,
				canPerformMatrixSnapshot: false,
				canViewAttachedMedia: false,
				canTriggerTestAlarm: false,
				canViewCCureLockdown: false,
				canEditCCureLockdown: false,
				canPromoteSelfToIC: false,
				canPerformQuickControlWithoutFootage: false,
				canViewCameras: false,
				canEditExternalMenuLinks: false,
				canViewExternalMenuLinks: false,
				canClaimEvents: false,
				canSelectConfigByCheckbox: false,
				canCreateCustomSQLReports: false,
				canShareReports: false,
				canShareReportsPublicly: false,
				canDispatchAssessor: false,
				canManualRaiseRegionally: false,
				canMaskPointsRegionally: false,
				canArmDisarmRegionally: false,
				canViewActionPlans: false,
				canEditActionPlans: false,
				canViewDispatchSetup: false,
				canEditDispatchSetup: false,
				canQuickControlRegions: false,
				canResetCCureRegions: false,
				canUseRegionsInViews: false,
				canManageDomains: false,
				canEditDomainGroups: false,
				canViewDomainGroups: false,
				canViewBadgeActivity: false,
				canEditLockUnlock: false,
				canSetDuressEventType: false,
				canRaiseDuress: false
			},
			alarmScreenTimeoutSeconds: null,
			alarmAgeWarningSeconds: null,
			dbFederationEnabled: false,
			canAddIndividualActionsOverride: false,
			allowEmptyAddressesOnAreas: false,
			permittedFileTypes: "",
			zoomLevelToLoadMapLayers: 0,
			collapseParentCategoryByDefault: false,
			quickControlMaxCameraRecordDuration: 0,
			hideLabels: false,
			requireMapPin: false,
			mapType: "",
			mapKey: null,
			mediaMatrixState: MatrixState.closed,
			dynamicLinkConfig: null,
			mediaMatrixConfig: {
				videoToursExpanded: false,
				clipsExpanded: false,
				camerasExpanded: false,
				controlsExpanded: false,
				areasExpanded: false,
				filesExpanded: false,
				audioExpanded: false
			},
			requireReasonUpdatingClearanceOnReaderGroups: false,
			additionalActionsOnForceRestoredAlarms: false,
			quickControlPrefs: {
				warning: "",
				regex: ""
			}
		},
		timeZoneAbbr: "",
		UserGroups: [],
		keyboardShortcuts: [],
		legendKeys: [],
		routingGroups: [],
		localUserData: null,
		version: null,
		serverName: null,
		featuresList: null,
		timeZones: null,
		ulTypes: [],
		accountCreationStatus: false,
		previousRoute: "",
		currentClipCells: null,
		loading: false,
		loginPreferences: {
			domainLoginAllowNoDomain: false,
			domainLoginSelectEnabled: false,
			ssoProviderSettings: {
				ssoEnabled: null, // this needs to be null to trigger the SSO settings check in singleSignOnHelper.ts
				ssoAutoRedirect: false,
				providerClientId: null,
				providerDomain: null,
				redirectUrl: null,
				authorizationEndpoint: null,
				providerType: null
			},
			ssoLoginButtonString: null
		}
	};
}
